import { Control, FieldErrors, Controller } from "react-hook-form"
import { motion } from "framer-motion"
import { User, Mail, Phone } from "lucide-react"
import { Input } from "@/components/ui/input"
import { QuoteFormData } from "@/lib/validations/quote-form"
import { FormFieldWrapper } from "./form-field-wrapper"

interface StepContactInfoProps {
  control: Control<QuoteFormData>
  errors: FieldErrors<QuoteFormData>
}

export function StepContactInfo({ control, errors }: StepContactInfoProps) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      className="grid grid-cols-1 md:grid-cols-3 gap-6"
    >
      <FormFieldWrapper
        icon={User}
        iconColor="bg-gradient-to-br from-blue-500 to-blue-600"
        label="Full Name"
        error={errors.name?.message}
        hoverBorderColor="group-hover:border-blue-500/30"
      >
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="text"
              placeholder="Enter your full name"
              className="bg-transparent focus:ring-0 text-base"
            />
          )}
        />
      </FormFieldWrapper>

      <FormFieldWrapper
        icon={Mail}
        iconColor="bg-gradient-to-br from-green-500 to-green-600"
        label="Email"
        error={errors.email?.message}
        hoverBorderColor="group-hover:border-green-500/30"
      >
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="email"
              placeholder="Enter your email"
              className="bg-transparent focus:ring-0 text-base"
            />
          )}
        />
      </FormFieldWrapper>

      <FormFieldWrapper
        icon={Phone}
        iconColor="bg-gradient-to-br from-orange-500 to-orange-600"
        label="Phone"
        error={errors.phone?.message}
        hoverBorderColor="group-hover:border-orange-500/30"
      >
        <Controller
          name="phone"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type="tel"
              placeholder="Enter your phone number"
              className="bg-transparent focus:ring-0 text-base"
            />
          )}
        />
      </FormFieldWrapper>
    </motion.div>
  )
}
